<script setup lang="ts">
import type { NuxtError } from 'nuxt/app';

defineOptions({
    inheritAttrs: false,
})

const props = defineProps<{
  error: NuxtError
}>()

const { t } = useI18n()

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
    <NuxtLayout name="error">
        <div class="notfound">
            <h1 class="notfound__title">{{ props.error.statusCode }} {{ t('page_not_found') }}</h1>
            <p class="notfound__desc">
                {{ t('page_not_found_desc') }}
            </p>
            <VBtn color="error" :text="t('back_to_home')" size="large" style="position: relative; z-index: 1" @click="handleError" />
        </div>
    </NuxtLayout>
</template>

<style lang="scss" scoped>
.notfound {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 100px);
    text-align: center;
    padding: 2rem 1.5rem;
    width: 90%;
    max-width: 700px;
    margin: auto;
    z-index: 10;

    &__title {
        font-size: clamp(1.5rem, 5vw, 2.5rem);
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 1rem;
        position: relative;
        z-index: 1;
    }

    &__desc {
        font-size: clamp(0.95rem, 2.5vw, 1.15rem);
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.7;
        margin-bottom: 2rem;
        max-width: 560px;
        position: relative;
        z-index: 1;
    }
}
</style>
